<template>
  <div
    :style="{ 'background-color': `${BGColorContent}`, 'width': `${mainFormWidth}px` }"
    style="min-height: calc(100vh);"
  >
    <menu-header
      v-if="name"
      :name="name"
      :isSecundary="isSecundary"

    />
    <div v-if="desktopView">
      <v-layout
        wrap
        v-for="(row, indexRows) in desktopView"
        :key="`rows${indexRows}`"
      >
      <v-flex
        v-for="(column, indexColumn) in row.Columns"
        :key="`column${indexColumn}`"
        v-bind="{ [column.Type]: true }"
      >
        <div 
          v-for="item in column.Contents"
          :key="`content${item.ID}`"
        >
          <!-- {{item}} -->
          <items
            :item="item"
            :menuID="menu.ID"
            :isMobile="false"
            :columnType="column.Type"
          />
        </div>
      </v-flex>
      </v-layout>
    </div>
    <div
    v-else
      v-for="item in isSimulation && editTMP && id === editTMP.ID && contents ? contents : apiContents"
      :key="`content${item.ID}`"
    >
      <items
        :item="item"
        :menuID="menu.ID"
        :isMobile="false"
      />
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import MenuHeader from '../MenuHeader'
  import api from '@/services/api'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import Items from '@/components/Items.vue'
  import dview from '@/services/dview-service'
  export default {
    components: {
      MenuHeader,
      Items
    },
    props: {
      menu: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      apiContents: [],
      isSecundary: false,
      name: null,
      desktopView: false
    }),
    computed: {
      ...mapState('app',['editTMP', 'contents', 'BGColorContent', 'ColorContent', 'mainFormWidth']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isMenu () {
        return constants.menusRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      touchPublic () {
         return this.$route.query.touchPublic ? true : false
      },
      title () { return 2 }
    },
    watch: {
      menu: {
        handler: function (newValue) {
          this.isSecundary = newValue.isSecundary
          this.name = newValue.Name
          this.getContent(newValue.ID)
        },
        deep: true
      }
    },
    mounted () {
      this.isSecundary = this.menu.isSecundary
      this.name = this.menu.Name
      this.getContent(this.menu.ID)
    },
    methods: {
      getContent(id) {
        this.desktopView = [] // solve bug pdf translate error
        // alert(id)
        api.getAll(`contents`, false, null, null, null, id).then(response => {
          
          // this.apiContents = response 
          if(this.touchPublic) response = response.filter(x => !x.HideTotem)
          this.apiContents = response.map(item => {
            item.IsActive = dview.isActive(item)
            return (item)
          }).filter(x => x.IsActive.date && x.IsActive.time || this.isSimulation)
          api.getAll(`menus/desktop-view`, false, null, null, null, id).then(responseDesktopView => {
            let rdv = responseDesktopView.struct ? JSON.parse(responseDesktopView.struct) : null
            if (rdv) {
              const ids = []
              for (let i = 0; i < rdv.length; i++) {
                for (let j = 0; j < rdv[i].Columns.length; j++) {
                  for (let k = 0; k < rdv[i].Columns[j].Contents.length; k++) {

                    const aux = this.apiContents.filter(x=>x.ID === rdv[i].Columns[j].Contents[k].ID).shift()
                    if (aux) {
                      rdv[i].Columns[j].Contents[k] = aux
                      ids.push(rdv[i].Columns[j].Contents[k].ID) // utilizado para obtener los ids del contenido configurado
                    }
                    //rdv[i].Columns[j].Contents[k] = this.apiContents.filter(x=>x.ID === rdv[i].Columns[j].Contents[k].ID) [0]
                    //ids.push(rdv[i].Columns[j].Contents[k].ID) // utilizado para obtener los ids del contenido configurado
                  } 
                } 
              }
              // Añadimos al una fila al final para todo el contenido no actualizado
              rdv.push({
                Columns: [
                  {
                    Type: 'xs12',
                    Contents: this.apiContents.filter(x=>ids.indexOf(x.ID) < 0)
                  }
                ]
              })
            }
            this.desktopView = rdv
          })
          // api.getAll(`contents`, false, null, null, null, id).then(response => {
          //   this.apiContents = response 
          // })
        })
      }
    }
  }
</script>
<style scoped>
</style>
